// src/components/OrderDetail.js
import React from "react";
import { formatDate, formatTimeFromTS } from "../utils/format";
import OrderTimeline from "./OrderTimeline";

export default function OrderDetail({
  selectedOrder,
  draft,
  timeline,
  loading,
  selectedStep,
  setSelectedStep,
  closeOrder,
}) {
  return (
    <>
      <button
        onClick={closeOrder}
        style={{
          background: "#CBD5E0",
          padding: "8px 16px",
          borderRadius: 8,
          border: "none",
          cursor: "pointer",
          fontWeight: 500,
          marginBottom: 20,
        }}
      >
        ← Volver a pedidos
      </button>

      <h2>
        Historial del Pedido #{selectedOrder.DocNum}
        {selectedOrder.CardName ? ` – ${selectedOrder.CardName}` : ""}
      </h2>

      {draft && (
        <div
          style={{
            background: "#fff",
            padding: 20,
            borderRadius: 12,
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            marginTop: 20,
          }}
        >
          <h3>Datos de Draft</h3>
          <p>
            <b>Cliente:</b> {draft.CardName}
          </p>
          <p>
            <b>Estado:</b> {draft.Estado}
          </p>
          <p>
            <b>Fecha de Creación:</b> {formatDate(draft.CreateDate)}{" "}
            {draft.CreateTS ? formatTimeFromTS(draft.CreateTS) : ""}
          </p>
          <p>
            <b>Vendedor:</b> {draft.SlpName}
          </p>
          <p>
            <b>Jefe de Ventas:</b> {draft.U_JEFE_VTAS}
          </p>
          <p>
            <b>Gte. de Ventas:</b> {draft.U_GTE_VENTAS}
          </p>
        </div>
      )}

      {loading ? (
        <p style={{ fontSize: 16, color: "#4A5568" }}>
          🔄 Cargando detalles del pedido...
        </p>
      ) : (
        <OrderTimeline
          timeline={timeline}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
        />
      )}
    </>
  );
}
